import React, { useEffect, useState } from 'react';
import { SparklesIcon } from '../lib/icons';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <nav className={`fixed top-0 left-0 right-0 z-[60] transition-all duration-300 ${isScrolled ? 'bg-[#1a1a2e]/95 backdrop-blur-md shadow-lg py-3' : 'bg-transparent py-5'}`} data-id="element-249">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-250">
        {/* Logo/Brand */}
        <div className="flex items-center gap-2" data-id="element-251">
          <SparklesIcon className="w-5 h-5 text-[#d4a017]" data-id="element-252" />
          <span className="text-white font-bold text-lg md:text-xl tracking-wide" style={{
          fontFamily: "'Cormorant Garamond', serif"
        }} data-id="element-253">
            Curso Integral de Reiki
          </span>
        </div>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-8" data-id="element-254">
          <button onClick={() => scrollTo('modules')} className="text-gray-300 hover:text-white text-sm font-medium transition-colors" data-id="element-255">
            Qué Incluye
          </button>
          <button onClick={() => scrollTo('benefits')} className="text-gray-300 hover:text-white text-sm font-medium transition-colors" data-id="element-256">
            Beneficios
          </button>
          <button onClick={() => scrollTo('testimonials')} className="text-gray-300 hover:text-white text-sm font-medium transition-colors" data-id="element-257">
            Testimonios
          </button>
        </div>
      </div>
    </nav>;
}